import React from "react";
import PropTypes from 'prop-types';
import Card from "@material-ui/core/Card/Card";
import {Checkbox} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import {Droppable} from "react-beautiful-dnd";
import CopyableList from "../../../../../../../Utils/DragDrop/CopyableList";
import makeStyles from "@material-ui/core/styles/makeStyles";


const useStyles = makeStyles(() => ({
    columnsWrapper: {
        width: 200,
        minHeight: 350,
        margin: 5,
        padding: 5
    },
    columnsHeader: {
        display: 'flex',
        alignItems: 'center'
    },
    cardContentWrapper: {
        height: 320,
        overflowY: 'auto'
    }
}));

const SourceColumns = ({source, destination, checkBoxChange, checkBoxAllChange}) => {
    const classes = useStyles();

    return (
        <Card className={classes.columnsWrapper}>
            <div className={classes.columnsHeader}>
                <Checkbox
                    checked={source.length > 0 && source.length === destination.length}
                    indeterminate={destination.length > 0 && source.length > destination.length}
                    size={"small"}
                    onChange={checkBoxAllChange}
                    style={{padding: 0, marginRight: 5}}
                    color={"primary"}
                />
                Field
            </div>
            <Divider/>
            <Droppable
                droppableId={'sourceItems'}
            >
                {(provided) => (
                    <div
                        className={classes.cardContentWrapper}
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                    >
                        <CopyableList
                            droppableId={'source'}
                            items={source}
                            destination={destination}
                            checkBoxChange={checkBoxChange}
                        />
                    </div>
                )}
            </Droppable>
        </Card>
    )
};
export default SourceColumns

SourceColumns.propTypes = {
    destination: PropTypes.array,
    source: PropTypes.array,
    checkBoxChange: PropTypes.func,
    checkBoxAllChange: PropTypes.func
};